import { compressSync, decompressSync } from "fflate";

const decoder = new TextDecoder();
const encoder = new TextEncoder();

function bufferToHex(buffer: Uint8Array) {
  return Array.prototype.map.call(buffer, (c) => c.toString(16).padStart(2, "0")).join("");
}

function hexToBuffer(hex: string) {
  const array = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    array[i / 2] = Number.parseInt(hex.substring(i, i + 2), 16);
  }
  return array;
}

export async function compress(str: string) {
  if (!str) {
    return "";
  }

  try {
    const buffer = encoder.encode(str);
    const compressedBuffer = compressSync(buffer, { level: 9, mem: 12 });
    return bufferToHex(compressedBuffer);
  } catch (error) {
    console.error("Error compressing value: ", error);
    return "";
  }
}

export async function decompress(hex: string) {
  if (!hex.includes("{")) {
    return "";
  }

  try {
    const compressedBuffer = hexToBuffer(hex);
    const buffer = decompressSync(compressedBuffer);
    return decoder.decode(buffer);
  } catch (error) {
    console.error("Error decompressing value: ", error);
    return "";
  }
}
